import React from "react";
import { Slider, Rail, Handles, Tracks } from "react-compound-slider";
import { Handle, SliderRail, Track } from "../components/SliderComponents";
import { useSelector, useDispatch } from "react-redux";
import { PRICELIMIT } from "../config";

const sliderStyle = {
  position: "relative",
  width: "100%",
};

export default function PriceFilter(props) {
  const { changeFilterAndSearch } = props;

  const loading = useSelector((state) => state.system.loading);

  const price = useSelector((state) => state.search.price);

  const [highPrice, setHighPrice] = React.useState(0);

  React.useEffect(() => {
    setHighPrice(price);
  }, [price]);

  const dispatch = useDispatch();

  let domain = [0, PRICELIMIT];

  return (
    <div
      className="pricefilter"
    >
      <span className="pricefilter1 filterheader">Gesamtbudget</span>
      <br />
      {/*lowPrice} EUR -*/} {highPrice}
      {highPrice === PRICELIMIT ? "+" : ""} EUR
      <br />
      <br />
      <Slider
        mode={2}
        step={10}
        domain={domain}
        disabled={loading > 0}
        rootStyle={sliderStyle}
        className="slider-root"
        onChange={(val) => {
          console.log("c", val);
          if (highPrice !== price) changeFilterAndSearch("price", val[0]);
        }}
        onUpdate={(val) => {
          //console.log("u", val);
          //setOutboundTime(val.join("-"));
          setHighPrice(val[0]);
        }}
        values={[highPrice * 1]}
      >
        <Rail>
          {({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}
        </Rail>
        <Handles>
          {({ handles, getHandleProps }) => (
            <div className="slider-handles">
              {handles.map((handle) => (
                <Handle
                  key={handle.id}
                  handle={handle}
                  domain={domain}
                  getHandleProps={getHandleProps}
                />
              ))}
            </div>
          )}
        </Handles>
        <Tracks left={false} right={false}>
          {({ tracks, getTrackProps }) => (
            <div className="slider-tracks">
              {tracks.map(({ id, source, target }) => (
                <Track
                  key={id}
                  source={source}
                  target={target}
                  getTrackProps={getTrackProps}
                />
              ))}
            </div>
          )}
        </Tracks>{" "}
      </Slider>
      <br />
    </div>
  );
}
